var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#BC1535;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M40,20c0,11.05-8.95,20-20,20h0C8.95,40,0,31.05,0,20v0C0,8.95,8.95,0,20,0h0C31.05,0,40,8.95,40,20L40,20z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 12.92,
    cy: 12.08,
    r: 2.58
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M14.87,29.25h-3.91c-0.11,0-0.19-0.09-0.19-0.19v-12.5c0-0.11,0.09-0.19,0.19-0.19h3.91 c0.11,0,0.19,0.09,0.19,0.19v12.5C15.06,29.16,14.98,29.25,14.87,29.25z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M29.66,21.09v7.3c0,0.47-0.39,0.86-0.86,0.86h-2.58c-0.47,0-0.86-0.39-0.86-0.86v-6.01 c0-1.18-0.96-2.15-2.15-2.15c-1.18,0-2.15,0.96-2.15,2.15v6.01c0,0.47-0.39,0.86-0.86,0.86h-2.58c-0.47,0-0.86-0.39-0.86-0.86 V17.23c0-0.47,0.39-0.86,0.86-0.86h2.58c0.47,0,0.86,0.39,0.86,0.86v0.55c0.86-1.11,2.28-1.84,3.86-1.84 C27.31,15.94,29.66,17.66,29.66,21.09z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.16cc3b95f341ddfad7ec452e2790bd01.svg";
export { ForwardRef as ReactComponent };